export default {
  path: '/printing_surface_thicknesses',
  name: 'printing_surface_thicknesses',
  component: () => import('../components/printingsurfacethickness/Layout'),
  redirect: { name: 'PrintingSurfaceThicknessList' },
  meta: {
    breadcrumb: 'profile.printingsurface.thickness',
  },
  children: [
    {
      name: 'PrintingSurfaceThicknessList',
      path: '',
      component: () => import('../views/printingsurfacethickness/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'PrintingSurfaceThicknessCreate',
      path: 'new',
      component: () => import('../views/printingsurfacethickness/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'PrintingSurfaceThicknessUpdate',
      path: ':id/edit',
      component: () => import('../views/printingsurfacethickness/Update'),
      meta: {
        breadcrumb: 'profile.printingsurface.thicknessname',
      },
    },
    {
      name: 'PrintingSurfaceThicknessShow',
      path: ':id',
      component: () => import('../views/printingsurfacethickness/Show'),
      meta: {
        breadcrumb: 'profile.printingsurface.thicknessname',
      },
    }
  ]
};
